import * as apiService from "../api";
import { getToken } from "../../helpers/common";
import * as API_URL from "../../constants/api";

export const updateLeadTransferStatus = async ({ id, status }) => {
  try {
    const token = getToken();
    const data = { id, status };
    const result = await apiService.post(
      API_URL.LEAD_TRANSFER_UPDATE,
      data,
      token,
    );
    return result;
  } catch (e) {
    return { status: false, data: {}, message: e.message };
  }
};

export const fetchLeadTransferStatus = async (id) => {
  try {
    const token = getToken();
    const url = `${API_URL.LEAD_TRANSFER_STATUS_FETCH}?id=${id}`;
    const result = await apiService.get(url, token);
    return result;
  } catch (e) {
    return { status: false, data: {}, message: e.message };
  }
};

export const fetchBitrixDataTransferAll = async () => {
  try {
    const token = getToken();
    const url = API_URL.LEAD_TRANSFER_BITRIX_FETCH_ALL;
    const result = await apiService.get(url, token);
    console.log("Bitrix Data Transfer All Result: ", result);
    return result;
  } catch (e) {
    return { status: false, data: {}, message: e.message };
  }
};

export const bulkUpdateBitrixDataTransfer = async (updates) => {
  try {
    const token = getToken();
    const result = await apiService.put(
      API_URL.LEAD_TRANSFER_BITRIX_BULK_UPDATE,
      updates,
      token,
    );
    return result;
  } catch (e) {
    return { status: false, data: {}, message: e.message };
  }
};
